import React from 'react'
import './styles.css'

const NotFoundPage = () => {
  return (
    <div className="page-not-found">Page not found</div>
  )
}

export default NotFoundPage